// import logo from './logo.svg';
// import './App.css';
import React from 'react';
import './components/Styles.css';
import Header from './components/Header';
import About from './components/AboutMe';
import Projects from './components/Projects';
// import Contact from './components/Contact';
import Footer from './components/footer';
import Work from './components/WorkExperience';
//import Footer from './components/footer';

function App() {
  //const [showProjects, setShowProjects] = useState(false);
  //const [showExperience, setShowExperience] = useState(false);

  //const handleProjectsClick = () => setShowProjects(true);
  //const handleExperienceClick = () => setShowExperience(true);
  return (
    <div>
      <Header/>
      <main>
        <About/>
        <Work/>
        <Projects/>
      </main>
      <Footer/>
    </div>
  );
}

export default App;
